/* Section: story — scroll-linked curtain wipe.
   Sets `--reveal` (0→1) on the section as it enters the viewport.
   Uses CSS scroll-driven animations where supported; this JS is the
   cross-browser fallback (Safari / older Firefox / Chrome <115). */
(() => {
  const section = document.querySelector('[data-section="story"]');
  if (!section) return;

  // If the browser can do scroll-driven animations, let CSS own it.
  const nativeOk = CSS?.supports?.('animation-timeline: view()');
  if (nativeOk) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    section.style.setProperty('--reveal', '1');
    return;
  }

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  let rafId = null;
  const update = () => {
    rafId = null;
    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    // Start when the top of the section first enters the viewport,
    // finish the wipe by the time the top is ~15% from the viewport top.
    const start = vh;              // rect.top = vh  → progress 0
    const end   = vh * 0.15;       // rect.top = 15% → progress 1
    const progress = clamp((start - rect.top) / (start - end), 0, 1);
    section.style.setProperty('--reveal', String(progress));
  };

  const schedule = () => {
    if (rafId != null) return;
    rafId = requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  // Kick once so sections already in view on load render correctly.
  update();
})();
